<template>
  <div class="pages-contacts">
    <BundlesPage />
  </div>
</template>

<style scoped lang="scss">
.pages-contacts {
  padding-top: em($gap-page-title);
  padding-bottom: em(185);

  @include media-breakpoint-down(sm) {
    padding-top: em($gap-page-title-sm);
    padding-bottom: em(86);
  }

  @include bundles-constructor-section {
    &:nth-child(2) {
      @include ctr-sidebar-section {
        &:nth-child(1) {
          margin-bottom: em(146);

          @include media-breakpoint-down(sm) {
            margin-bottom: em(67);
          }
        }

        &:nth-child(2) {
          margin-bottom: em(103);

          @include media-breakpoint-down(sm) {
            margin-bottom: em(64);
          }
        }
      }
    }
  }
}
</style>
